import { ptBR } from "./pt-BR";

// ponytail: dicionário próprio com um idioma só. Trocar por react-i18next quando
// a segunda língua entrar de fato: as chaves e as variáveis {{x}} são compatíveis.

export const LOCALE = "pt-BR";

// "common.retry" | "offline.banner" | … derivado do próprio pt-BR: chave errada não compila.
type Paths<T, P extends string = ""> = {
  [K in keyof T & string]: T[K] extends string ? `${P}${K}` : Paths<T[K], `${P}${K}.`>;
}[keyof T & string];
export type MessageKey = Paths<typeof ptBR>;

export function t(key: MessageKey, vars?: Record<string, string | number>): string {
  const text = key.split(".").reduce<unknown>((node, k) => (node as Record<string, unknown>)[k], ptBR) as string;
  return vars ? text.replace(/\{\{(\w+)\}\}/g, (_, name) => String(vars[name] ?? "")) : text;
}

export const formatDate = (value: Date | string | number, options: Intl.DateTimeFormatOptions = { dateStyle: "short" }) =>
  new Intl.DateTimeFormat(LOCALE, options).format(new Date(value));

/** Valores em centavos, como vêm do backend e do Stripe. */
export const formatCurrency = (cents: number, currency = "BRL") =>
  new Intl.NumberFormat(LOCALE, { style: "currency", currency }).format(cents / 100);

const pluralRules = new Intl.PluralRules(LOCALE);

/** plural(n, { zero: "Nenhum pedido", one: "1 pedido", other: "{{count}} pedidos" }) */
export function plural(count: number, forms: { zero?: string; one: string; other: string }): string {
  const form = count === 0 && forms.zero ? forms.zero : pluralRules.select(count) === "one" ? forms.one : forms.other;
  return form.replace("{{count}}", String(count));
}
